import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const changelogEntries = [
  {
    version: 'v0.11.0',
    changes: [
      'Added option to delete files in the Review & Reorder step.',
      'Enhanced drag-and-drop behavior in the Review & Reorder step.',
      'Introduced a mobile card view for the Review & Reorder step (replaces the table layout).',
      'Added page numbers (x of y).'
    ]
  },
  {
    version: 'v0.10.1',
    changes: [
      'Minor code improvements.',
    ]
  },
  {
    version: 'v0.10.0',
    changes: [
      'Implemented drag-and-drop reordering on the review page',
    ]
  },
  {
    version: 'MVP 9.0',
    changes: [
      'Smart phone portrait image orientation is now automatically corrected.',
      'Review page now includes direct links to each uploaded document.'
    ]
  },
  {
    version: 'MVP 8.1',
    changes: [
      'Add an optional description below your cover title.',
      'Binder now automatically adjusts vertical spacing to avoid overlap.',
      'Long descriptions wrap neatly across lines for better readability.'
    ]
  },
  {
    version: 'MVP 8.0',
    changes: [
      'Save and reload your work via .json project export.',
      'Full camera and webcam support for mobile and desktop.',
      'Portrait photo warning and retake option to avoid poor layout in PDF.',
      'New project button to quickly start fresh.',
      'Metadata totals displayed on the cover page.'
    ]
  },
  {
    version: 'MVP 6.0',
    changes: [
      'Metadata can now be attached per document.',
      'Camera preview with retake option on mobile.',
      'Desktop webcam capture support.',
      'Layout adjusts when camera is inactive.'
    ]
  },
  {
    version: 'MVP 5.0',
    changes: [
      'Improved wizard flow for better metadata entry experience.'
    ]
  },
  {
    version: 'MVP 4.0',
    changes: [
      'Cover page includes a metadata table.',
      'Sum fields are calculated and displayed.'
    ]
  },
  {
    version: 'MVP 3.0',
    changes: [
      'Switched to jspdf-autotable for improved table rendering.',
      'Cover title is centered and styled.'
    ]
  },
  {
    version: 'MVP 2.0',
    changes: [
      'PDF generation includes metadata, images, and native PDFs.',
      'Standardized formatting: A4, mm, Helvetica.',
      'Avoided quality loss by embedding PDFs directly.'
    ]
  },
  {
    version: 'MVP 1.0',
    changes: [
      'Initial release of Binder.',
      'Upload PDF, JPG, or PNG documents.',
      'Annotate with metadata through a step-by-step wizard.',
      'Generate bundled PDF with a cover page.',
      'Fully client-side and offline — privacy-friendly.'
    ]
  }
];

const ChangelogModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>What's new in Binder</DialogTitle>
      <DialogContent dividers>
        {changelogEntries.map((entry, index) => (
          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDownwardIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span" fontWeight="bold">{entry.version}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {entry.changes.map((change, i) => (
                  <ListItem disablePadding>
                    <ListItemIcon>
                      <ArrowRightIcon />
                    </ListItemIcon>
                    <ListItemText primary={change} />
                  </ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangelogModal;